<div class="auth-layout-wrap"
    style="background-image: url(./assets/images/warehouse.jpg)">
    <div class="auth-content">
        <router-outlet></router-outlet>
    </div>
    <p class="attribution" style="opacity: 0.5;"> <a href="https://www.freepik.com/free-ai-image/large-warehouse-stack-crates-boxes-containers-generated-by-ai_41283306.htm#query=inventory%20management%20background%20image&position=31&from_view=search&track=ais&uuid=19f2f4a0-8f8e-4ce4-85b0-48a10e45d86c">Image By vecstock</a> </p>
</div>